import React from 'react'
import styled from 'styled-components'
import { useI18nFunction } from '../I18n'
import checkCircle from '../../icons/check_circle.svg'
import errorOrange from '../../icons/error_orange.svg'
import warning from '../../icons/warning.svg'

const ItemRemarks = ({ Case, confirmed }) => {
  const I18nFunction = useI18nFunction();

  let icon = warning
  let tooltip = I18nFunction({ id: 'item_remarks.unconfirmed_no_conflict' })
  if (confirmed) {
    icon = checkCircle
    tooltip = I18nFunction({ id: 'item_remarks.confirmed_no_conflict' })
    if (Case?.organizationIsSupplierForUserCompany || Case?.organizationIsCustomerForUserCompany) {
      icon = errorOrange
      tooltip = I18nFunction({ id: 'item_remarks.confirmed_conflict' })
    }
  }
  if (!confirmed && (Case?.organizationIsSupplierForUserCompany || Case?.organizationIsCustomerForUserCompany)) {
    tooltip = I18nFunction({ id: 'item_remarks.unconfirmed_conflict' })
  }
  return (
    <MarkerWrapper>
      <Icon src={icon}></Icon>
      <Tooltip>{tooltip}</Tooltip>
    </MarkerWrapper>
  )
}

const MarkerWrapper = styled.div`
  display: inline-block;
  border-radius: 10px;
  margin: 2px;
`

const Icon = styled.img`
height: 2em;
`

const Tooltip = styled.div`
  z-index: 5;
  display: none;
  position: absolute;
  margin: 0;
  padding: 1em;
  margin-left: 1em;
  width: 200px;
  height: auto;
  background-color: ${({ theme: { primary } }) => primary};
  color: ${({ theme: { inverseText } }) => inverseText};
  border-radius: 5px;
  border: 1px black solid;
  ${MarkerWrapper}:hover & {
    display: block;
  }
`

export default ItemRemarks
